<template>
    <div>
        <template v-if="isBuilt">
            <template v-if="tableData.showAsTriple">
                <three-columns :tableData="tableData" :isBuilt="isBuilt" :hasSkb="hasSkb"></three-columns>
            </template>
            <template v-else>
                <two-columns :tableData="tableData" :isBuilt="isBuilt" :hasSkb="hasSkb"></two-columns>
            </template>
        </template>
        <template v-else>
            <two-columns v-if="tableData.cols==2" :tableData="tableData" :hasSkb="hasSkb"></two-columns>
            <three-columns v-if="tableData.cols==3" :tableData="tableData" :hasSkb="hasSkb"></three-columns>
        </template>
    </div>
</template>

<script>
    import twoColumns from './tableTypes/TripleTableTwoColumns.vue';
    import threeColumns from './tableTypes/TripleTableThreeColumns.vue';
    export default {
        props: ['isBuilt', 'hasSkb', 'tableData'],
        created(){
            event_bus.$on('current_dwm', () => {
                this.current_dwm = this.$store.state.current_dwm;
                event_bus.$emit('reloading', true);
            });
        },
        components: {
            'twoColumns': twoColumns,
            'threeColumns': threeColumns
        }
    }
</script>
